import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const MyCurrentLocation = (_param)=> {
    var { label , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('my-current-location-stores-v2', className)
    }), /*#__PURE__*/ React.createElement(Icon, {
        name: "gps"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "my-current-location-stores-v2__label"
    }, label));
};

export { MyCurrentLocation as default };
//# sourceMappingURL=MyCurrentLocation.js.map
